import jwt_decode, { JwtPayload } from 'jwt-decode';

/**
 * Gets number of milliseconds left for JWT before it's expired
 * @param token JWT to calculate milliseconds
 * @returns Number of milliseconds before JWT is expired
 */
export const getTokenMillisecondsLeft = (token: string): number => {
  const tokenPayload = jwt_decode<JwtPayload>(token);
  const tokenExpiration: number = new Date(0).setUTCSeconds(tokenPayload.exp || 0);

  return tokenExpiration - Date.now();
};
